import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowTopLeftFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M7.46 16.56H5.62V5.52H16.66V7.36H8.82L18.38 16.94L17.04 18.28L7.46 8.68V16.56Z" />
    </SvgIcon>
  );
});
